import React from 'react'

const Add = props => (
  <svg
    width='21'
    height='21'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <defs>
      <path
        d='M11.4583333 13.5416667v8.4280303c0 .5229969.4663701.9469697 1.0416667.9469697.5752966 0 1.0416667-.4239728 1.0416667-.9469697v-8.4280303h8.4280303c.5229969 0 .9469697-.4663701.9469697-1.0416667 0-.5752966-.4239728-1.0416667-.9469697-1.0416667h-8.4280303V3.03030303c0-.52299692-.4663701-.9469697-1.0416667-.9469697-.5752966 0-1.0416667.42397278-1.0416667.9469697v8.42803027H3.03030303c-.52299692 0-.9469697.4663701-.9469697 1.0416667 0 .5752966.42397278 1.0416667.9469697 1.0416667h8.42803027z'
        id='addIconA'
      />
    </defs>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <path d='M0 0h25v25H0z' />
      <mask id='addIconB' fill='#fff'>
        <use xlinkHref='#addIconA' />
      </mask>
      <path
        d='M0 0h25v25H0z'
        mask='url(#addIconB)'
        fill='#C78C2F'
        id='plus-icon'
      />
    </g>
  </svg>
)

export default Add



// WEBPACK FOOTER //
// ./src/svg-icons/Add.js